module.exports = __webpack_public_path__ + "bbcb0ed6554a02fad3efa4d5349d7acd.jpg";